/**
 * Model-switch scope dialog.
 *
 * When a user loads a different model while a conversation is active, ask
 * whether to keep using the current conversation or start a new one.
 * Returns 'here' | 'new' | 'cancel'.
 */

let overlayEl = null;
let dialogEl = null;
let resolveFn = null;

function ensureBuilt() {
    if (dialogEl) return;
    const html = `
        <div id="model-switch-overlay" class="confirm-overlay"></div>
        <div id="model-switch-dialog" class="confirm-dialog">
            <div class="confirm-header">
                <h3 id="model-switch-title">Switch model</h3>
            </div>
            <div class="confirm-body">
                <p id="model-switch-message"></p>
            </div>
            <div class="confirm-footer model-switch-footer">
                <button id="model-switch-cancel" class="confirm-btn cancel">Cancel</button>
                <button id="model-switch-new" class="confirm-btn primary">Start new conversation</button>
                <button id="model-switch-here" class="confirm-btn primary">Use in this conversation</button>
            </div>
        </div>
    `;
    document.body.insertAdjacentHTML('beforeend', html);
    overlayEl = document.getElementById('model-switch-overlay');
    dialogEl = document.getElementById('model-switch-dialog');

    overlayEl.addEventListener('click', () => close('cancel'));
    document.getElementById('model-switch-cancel').addEventListener('click', () => close('cancel'));
    document.getElementById('model-switch-new').addEventListener('click', () => close('new'));
    document.getElementById('model-switch-here').addEventListener('click', () => close('here'));
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && dialogEl?.classList.contains('open')) close('cancel');
    });
}

function close(choice) {
    overlayEl?.classList.remove('active');
    dialogEl?.classList.remove('open');
    document.body.style.overflow = '';
    if (resolveFn) { resolveFn(choice); resolveFn = null; }
}

/**
 * Ask the user where a model switch should apply.
 * @param {string} modelName - display name of the model being loaded
 * @returns {Promise<'here'|'new'|'cancel'>}
 */
export function chooseModelSwitchScope(modelName) {
    ensureBuilt();
    document.getElementById('model-switch-message').textContent =
        `Switch to ${modelName}. Keep working in this conversation, or start a new one?`;
    overlayEl.classList.add('active');
    dialogEl.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.getElementById('model-switch-here').focus();
    return new Promise(resolve => { resolveFn = resolve; });
}
